import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import StoryCard from "@/components/feature/StoryCard";
import { stories } from "@/mocks/stories";

export default function FeaturedStories() {
  const featured = stories.slice(0, 3);

  return (
    <section className="bg-background-50">
      <div className="max-w-editorial mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            eyebrow="亲述档案"
            title="他们把最难开口的部分写了下来"
            description="以下内容均由当事人授权整理，姓名、单位与可识别信息已作模糊处理。"
          />
          <Link
            to="/stories"
            className="shrink-0 inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors"
          >
            查看全部档案
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}